<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="String(size)"
    :height="String(size)"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="yn-svg-icon yn-svg-icon-codepen"
  >
    <polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2" /><line x1="12" y1="22" x2="12" y2="15.5" /><polyline points="22 8.5 12 15.5 2 8.5" /><polyline points="2 15.5 12 8.5 22 15.5" /><line x1="12" y1="2" x2="12" y2="8.5" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [String, Number], default: '16' },
  strokeWidth: { type: [String, Number], default: 2 },
})
</script>
